import { format } from 'date-fns'
import { ExperienceSearchParams } from '@reward-platform/ancillaries-schemas/experience'
import { useQueryStateToFormState } from '~/components/search-and-results/ExperienceResults/useQueryToFormState'
import { useQueryParams } from '../useQueryParams/useQueryParams'

/** Analytics reads the searched destination and dates from the current URL. */
export const useExperienceQueryData = () => {
  const { query } = useQueryParams<ExperienceSearchParams>()
  const defaultValues = useQueryStateToFormState(query)
  const { destination } = defaultValues
  const fromDate = format(defaultValues.startDateTime, 'y-MM-dd')
  const toDate = defaultValues.endDateTime ? format(defaultValues.endDateTime, 'y-MM-dd') : 'N/A'

  return { destination, fromDate, toDate }
}
